import React, {useRef, useState} from "react";
import {Col, Overlay, Row, Tooltip} from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {FaJava,FaLaravel} from 'react-icons/fa';

import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
    DiDjango,
} from "react-icons/di";
import {
  SiPhp,
  SiFirebase,
  SiMysql,
    SiSpring
} from "react-icons/si";

function Techstack() {
    const [c, setC] = useState(false);
  const targetC = useRef(null);
  const [java, setJava] = useState(false);
  const targetJava = useRef(null);
  const [py, setPy] = useState(false);
  const targetPy = useRef(null);
  const [php, setPhp] = useState(false);
  const targetPhp = useRef(null);
  const [js, setJs] = useState(false);
  const targetJs = useRef(null);
  const [react, setReact] = useState(false);
  const targetReact = useRef(null);
  const [django, setDjango] = useState(false);
  const targetDjango = useRef(null);
  const [laravel, setLaravel] = useState(false);
  const targetLaravel = useRef(null);
  const [node, setNode] = useState(false);
  const targetNode = useRef(null);
  const [spring, setSpring] = useState(false);
  const targetSpring = useRef(null);
  const [git, setGit] = useState(false);
  const targetGit = useRef(null);
  const [mysql, setMysql] = useState(false);
  const targetMysql = useRef(null);
  const [mongo, setMongo] = useState(false);
  const targetMongo = useRef(null);
  const [fire, setFire] = useState(false);
  const targetFire = useRef(null);

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2}  className="tech-icons" ref={targetC} onMouseOver={() => setC(!c)} onMouseLeave={() => setC(false)}>
        <CgCPlusPlus />
      </Col>

        <Overlay target={targetC.current} show={c} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            C++
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetJava} onMouseOver={() => setJava(!java)} onMouseLeave={() => setJava(false)}>
        <FaJava/>
      </Col>
          <Overlay target={targetJava.current} show={java} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Java
          </Tooltip>
        )}
      </Overlay>

         <Col xs={4} md={2} className="tech-icons" ref={targetPy} onMouseOver={() => setPy(!py)} onMouseLeave={() => setPy(false)}>
        <DiPython/>
      </Col>

          <Overlay target={targetPy.current} show={py} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Python
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetPhp} onMouseOver={() => setPhp(!php)} onMouseLeave={() => setPhp(false)}>
        <SiPhp />
      </Col>

          <Overlay target={targetPhp.current} show={php} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            PHP
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetJs} onMouseOver={() => setJs(!js)} onMouseLeave={() => setJs(false)}>
        <DiJavascript1 />
      </Col>

          <Overlay target={targetJs.current} show={js} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Java script
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetReact} onMouseOver={() => setReact(!react)} onMouseLeave={() => setReact(false)}>
        <DiReact />
      </Col>

          <Overlay target={targetReact.current} show={react} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            React js
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetDjango} onMouseOver={() => setDjango(!django)} onMouseLeave={() => setDjango(false)}>
        <DiDjango />
      </Col>

          <Overlay target={targetDjango.current} show={django} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Django
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetSpring} onMouseOver={() => setSpring(!spring)} onMouseLeave={() => setSpring(false)}>
        <SiSpring/>
      </Col>
          <Overlay target={targetSpring.current} show={spring} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Spring boot
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetLaravel} onMouseOver={() => setLaravel(!laravel)} onMouseLeave={() => setLaravel(false)}>
        <FaLaravel />
      </Col>
          <Overlay target={targetLaravel.current} show={laravel} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Laravel
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetNode} onMouseOver={() => setNode(!node)} onMouseLeave={() => setNode(false)}>
        <DiNodejs />
      </Col>

          <Overlay target={targetNode.current} show={node} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            node js
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetMysql} onMouseOver={() => setMysql(!mysql)} onMouseLeave={() => setMysql(false)}>
        <SiMysql />
      </Col>
          <Overlay target={targetMysql.current} show={mysql} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            My SQL
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetMongo} onMouseOver={() => setMongo(!mongo)} onMouseLeave={() => setMongo(false)}>
        <DiMongodb />
      </Col>
          <Overlay target={targetMongo.current} show={mongo} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Mongo DB
          </Tooltip>
        )}
      </Overlay>

        <Col xs={4} md={2} className="tech-icons" ref={targetFire} onMouseOver={() => setFire(!fire)} onMouseLeave={() => setFire(false)}>
        <SiFirebase />
      </Col>
          <Overlay target={targetFire.current} show={fire} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Firebase
          </Tooltip>
        )}
      </Overlay>

      <Col xs={4} md={2} className="tech-icons" ref={targetGit} onMouseOver={() => setGit(!git)} onMouseLeave={() => setGit(false)}>
        <DiGit />
      </Col>
          <Overlay target={targetGit.current} show={git} placement="top" >
        {(props) => (
          <Tooltip id="overlay-example" {...props} >
            Git
          </Tooltip>
        )}
      </Overlay>


    </Row>
  );
}

export default Techstack;
